// React
import React from 'react';
import { useTranslation } from 'react-i18next';

// Libs
import { Card, Table } from 'semantic-ui-react';

// Components
import CopyContentComponent from '../../../misc/CopyContent.component';

// Types
import { generalState } from '../../../../model/details/general';
import { GeneralState } from '../../../../types/General';

type LeadGeneralComponentProps = {
    data: typeof generalState;
    copy?: boolean;
};

/**
 * Box shows general data with. Set range in `matrix` variable.
 *
 * @param props LeadGeneralComponentProps
 * @returns React.ReactElement
 */
export default function LeadGeneralComponent(props: LeadGeneralComponentProps): React.ReactElement {
    const { t } = useTranslation();

    const matrix: Array<keyof GeneralState> = [
        'leadSource',
        'armadaCustomerId',
        'leasmanCustomerId',
        'leadState',
        'type',
        'leadId',
        'creationTimestamp',
    ];

    function createValue(value: string): React.ReactElement {
        return props.copy ? <CopyContentComponent>{value}</CopyContentComponent> : <>{value || ''}</>;
    }

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header>{t('lead.detail.box.general.headline')}</Card.Header>
                <Card.Description>
                    <Table celled striped columns={2}>
                        <Table.Body>
                            {matrix.map((key: string, ix) => (
                                <Table.Row key={ix}>
                                    <Table.Cell width={4}>{t(`lead.detail.box.general.${key}`)}</Table.Cell>
                                    <Table.Cell singleLine>{createValue(props.data[key])}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
        </Card>
    );
}
